<template>
    <div>
      <!-- 单选 -->
      <Select
        v-if="isMultiple == 2"
        :ref="refName"
        :filterable="filterable"
        remote
        transfer
        :clearable="clearable"
        :loading="loading"
        :remote-method="fileQueryChange"
        @on-clear="clearData"
        @on-query-change="fileQueryChange"
        :placeholder="placeholderText"
        :label-in-value="labelInValue"
        :title="titleName"
        style="width: 300px;"
      >
      <recycle-scroller
          class="virtual-list"
          :buffer="200"
          :prerender="10"
          :style="'height:'+selectHeight+'px'"
          :item-size="30"
          :key-field="valName"
          :items="dataListA">
          <template v-slot="{ item, index }">
            <Option :disabled="item.disabled"  :label="item[labelName] + ''" :value="item[valName]+ ''" :key="item[valName]"  style="display:flex;align-items: center;justify-content: space-between" @click.native="setVal(item)" :title="item[labelName]+' '+ (item[labelNameNew]?item[labelNameNew]:'')"><span>{{ item[labelName] }}</span><span v-if="labelNameNew">{{ item[labelNameNew] }}</span></Option>
          </template>
        </recycle-scroller>
  
  
      </Select>
    </div>
  </template>
  <script>
      import common from '@/common/common.js';
      import { mapState } from 'vuex'
      export default {
          name: "selectList",
          components: {
          },
          props: {
              url: String,//接口的链接
              selectUrlQuery:{
                  type:Object,
                  default:()=>{}
              },
              valName: String,//传入后台的值
              labelName: String,//对外显示的说明
              refName: String,//对外显示的说明
              isMultiple:{ //是否多选  1  多选 2单选 3 单选 直接数据
                  type: [Number,String],
                  default: 2
              },
              labelInValue:{//是否显示label,默认只返回 value
                  type: Boolean,
                  default: false
              },
              filterable:{//是否支持远程搜索。默认支持
                  type: Boolean,
                  default: true
              },
              keyword: { //搜索词的字段名
                  type: String,
                  default: ''
              },
              labelNameNew: { //备注字段
                  type: String,
                  default: ''
              },
              clearable:{//是否可清空
                  type: Boolean,
                  default: true
              },
              checkedList:{//选中的值 多选时传入数组
                  type: String|Array,
                  default: ''
              },
              placeholderText:{// :placeholderText="type==1?$t('selectPlaceholder'):$t('selectloadingPlaceholder')"  编辑时，没有回显显示为加载中新增时直接显示请选择
                  type:[String,Number],
                  default:'请输入'
              },
              index:{//操作对应的索引
                  type: Number,
                  default: 0
              },
              selectHeight:{//下拉框高度
                  type: Number,
                  default: 180
              },
              allowCreate:{
                  type: Boolean,
                  default: false
              },
              needName:{
                  type:String,
                  default:''
              },
              addAll:{
                  type:String,
                  default:''
              },
              listName:{
                  type:String,
                  default:''
              },
              hasDealerId:{//有些接口不能包含dealerId，默认为包含
                  type: Boolean,
                  default: true
              },
              wordList:{
                  type: Array,
                  default: ()=>[]
              },
              errorShow:{//code不为1时是否提示错误信息
                type: Boolean,
                default: false
            }
          },
          data() {
              return {
                  loading:false,
                  setvalObj:null,
                  dataList:[],
                  dataListA:[],
                  hasChecked:[],
                  titleName:''
              }
          },
          computed:{
               ...mapState(['local','uInfo','selectId']),
          },
  
          created() {
          },
          mounted() {
              this.$nextTick(() => {
                  this.$refs[this.refName].validateOption = () => true;
              })
              // this.getData()
          },
          destroyed() {
          },
          methods: {
              setVal(item){//选定值，传给父
                  if (!item) return
  
                  this.$refs[this.refName].values = []
                  this.$refs[this.refName].values.push({
                      label: item[this.labelName],
                      tag: undefined,
                      value: item[this.valName]
                   })
                  this.titleName = item[this.labelName]
                   this.$emit('setSelected', item||null)
              },
              clearData(){//清空数据，重新赋值
                  this.$refs[this.refName].values = []
                  this.$emit('setSelected', null)
                  this.dataListA = common.deepClone([...this.dataList])
              },
              fileQueryChange(v) {//重写搜索方法
                if (v) {
                  let res = this.dataList.filter(f => (f[this.labelName]+'').indexOf(v) >= 0 || (f[this.labelNameNew]+'').indexOf(v) >= 0)
                  let data = common.deepClone([...res])
                  this.dataListA = data
                 
                } else {
                  this.dataListA = common.deepClone(this.dataList)
                }
  
              },
              async getData(){//获取列表信息,,,remote执行一次，初始执行一次
                  
                  let objData = {
                          dealerId:this.selectId,
                          page:1,
                          limit:20000,
                          ...this.selectUrlQuery,
                      
                  }
  
                  // console.log('wordList',this.wordList)
                  if(this.hasDealerId==false){
                      delete objData.dealerId
                  }
                  // console.log('getDatagetDatagetData',objData)
                 
                  this.loading = true;
        
                  setTimeout(() => {
                      this.axios.post(this.url,objData).then((result) => {
                          // console.log(result.data)
                          this.loading = false;
                          //处理数组
                          // console.log('result',result)
                          if(result.data.code == 1){
                              if(this.isMultiple == 3){
                                  this.dataList = result.data.data
                              }else{
                                  if(!result.data.data.meta){
                                      this.dataList = result.data.data
                                  }else{
                                      this.dataList = result.data.data[this.listName]
                                  }
                              }
                              
                              // 筛选出06 07的
                            //   this.dataList = this.dataList.filter(f =>{
                            //          return f.commandKeyType==6 || f.commandKeyType==7  || (f.identifier && (f.identifier.startsWith('06_') || f.identifier.startsWith('07_')))
                                      
                            //    })

                              // 筛选出不包含08的
                            //   this.dataList = this.dataList.filter(f =>{
                            //          return f.commandKeyType != 8 && (f.identifier && (!f.identifier.startsWith('08_')))
                                      
                            //    })

                            //    console.log(' this.dataList this.dataList', this.dataList)

                            // 筛选出含有keyName的
                              this.dataList = this.dataList.filter(f =>{
                                     return f.hasOwnProperty('keyName')
                                      
                               })
  
  
                               this.dataList = this.dataList.map(f =>{
                                    let keyNameObj = {}
                                    let formatContentObj = {}
                                    
                                    try {
                                        keyNameObj = JSON.parse(f.keyName)
                                        formatContentObj = JSON.parse(f.formatContent)
                                    } catch (error) {
                                        
                                    }

                                    
                                   
                                     f.keyNameText = this.local=='zh-CN'? keyNameObj['CN']:keyNameObj['EN']
                                    //  console.log('f.keyNameText',f.keyNameText)
                                     f.keyNameText =f.keyNameText?f.keyNameText:(f.identifier?f.identifier:'')


                                      f.id = f.identifier?f.identifier:f.commandKeyType+'_'+f.commandKey;
  
                                      return f
                               })
                               this.dataList = this.dataList.sort((obj1, obj2)=>{
                                  var value1 = obj1['sortNumber'];
                                  var value2 = obj2['sortNumber'];
                                  return value1 - value2; // 升序
  
                               })
                              //  console.log('this.dataListthis.dataList',this.dataList)
  
                              
                              if(this.setvalObj){
                                  this.$refs[this.refName].values = []
                                  let res = this.dataList.filter(f =>{
                                      return  (f[this.valName])==this.setvalObj[this.valName] || (f[this.labelName])==this.setvalObj[this.labelName]
                                  })
  
  
                                  if(res && res.length==1){
                                      this.$refs[this.refName].values.push({
                                          label: this.setvalObj[this.labelName],
                                          tag: undefined,
                                          value: this.setvalObj[this.valName]
                                      })
                                      // console.log('res[0]res[0]',res[0])
                                      // 在这赋值的目的是为了源码写入那里，中英文输入有误的情况
                                      this.setVal(res[0])
                                  }
                              }
  
                              this.dataListA = common.deepClone([...this.dataList])

                              if(this.dataList.length ==0 ){
                                    let finallyData={
                                        [this.valName]:1,
                                        [this.labelName]:'暂无数据',
                                        disabled:true
                                    };
                                    this.dataListA = [
                                        finallyData
                                    ]
                               }
  
                            //   if(this.dataList.length==0 && this.needName){//必须有数据，不然提示请先创建数据
                            //       let id = this.valName
                            //       let val = this.labelName
                            //       let finallyData={};
                            //       finallyData[id] = ''
                            //       finallyData[val] = this.needName
                            //       finallyData['disabled'] = true
                            //       this.dataList.push(finallyData)
                            //       // common.msg('error','请先创建'+this.needName)
                            //   }
                              if(this.dataList.length>0 && this.addAll){//全部类别，加到第一个，好麻烦哦
                                
                                  let id = this.valName
                                  let val = this.labelName
                                  let finallyData={};
                                  finallyData[id] = '0'
                                  finallyData[val] =this.$t(this.addAll)
                                  this.dataList.unshift(finallyData)
  
                              }
                              this.setvalObj = null
                          }else{
                              this.setvalObj = null
                              if(this.errorShow){
                                let finallyData={
                                    [this.valName]:1,
                                    [this.labelName]:result.data.message || 'error',
                                    disabled:true
                                };
                                this.dataListA = [
                                    finallyData
                                ]

                                common.msg('error',result.data.message,()=>{
                                })
                            }
                          }
                      }).catch((err) => {
                          // console.log(err)
                          this.loading = false;
                          this.setvalObj = null
          
                          // common.msg('error','获取失败',()=>{})
                      })
  
                  }, 200);
              },
              async setDefVal(item){//设置默认值
                  // console.log('setDefValsetDefValsetDefValsetDefVal',item)
                  // console.log('this.dataList',this.dataList)
                  
                  if(!item){
                      this.$refs[this.refName].values = []
                      return
                  }
                  this.setvalObj = item
  
                  if(this.dataListA.length){
  
                      this.$refs[this.refName].values = []
                      let res = this.dataListA.filter(f =>{
                          return  (f[this.valName])==this.setvalObj[this.valName] || (f[this.labelName])==this.setvalObj[this.labelName]
                      })
                      if(res && res.length==1){
                          this.$refs[this.refName].values.push({
                              label: this.setvalObj[this.labelName],
                              tag: undefined,
                              value: this.setvalObj[this.valName]
                          })
                          // console.log('res[0]res[0]',res[0])
                          // 在这赋值的目的是为了源码写入那里，中英文输入有误的情况
                          this.setVal(res[0])
                          this.setvalObj = null
                      }
                  }else{
                      this.getData()
                  }
                
                  
              },
              clearVal(){//弹窗关闭时，调用clearVal，，清空数据
                  this.dataList = []
                  this.dataListA = []
                  this.$refs[this.refName].values = []
              }
          }
      }
  </script>
  <style scoped>
  
    .feedbackText {
      font-size: 10px;
    }
    .ivu-select-dropdown{
    max-width: 300px;
    overflow:auto
  }
  </style>
  